import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, DatePicker, Form, Modal, notification, Row, Select } from 'antd';
import dayjs from 'dayjs';
import { formatDateForServer } from '../../../helpers/utils';
import reportService from '../../../services/report.service';

const { Option } = Select;

const AddAnInvoiceModal = ({ visible, closeModal, branches = [], identificationNumber }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleCloseModal = () => {
    closeModal();
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      const body = {
        ...values,
        EndDate: formatDateForServer(values.EndDate),
      };

      try {
        await reportService.manualInvoicing(identificationNumber, body);
        notification.success({
          message: 'İşlem Başarılı',
          description: 'Manuel Fatura Kesme İşlemi Başarılı.',
        });
        setLoading(false);
        closeModal();
      } catch (error) {
        setLoading(false);
        notification.error({
          message: 'İşlem Başarısız',
          description: error.message || 'Bir hata oluştu.',
        });
      }
    } catch (err) {
      console.error('Validation Failed:', err);
    }
  };

  const renderBranchOptions = () => {
    return branches?.map((branch) => (
      <Option key={branch.BranchId} value={branch.BranchId}>
        {branch.BranchTitle}
      </Option>
    ));
  };

  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < dayjs().subtract(7, 'days');
  };

  return (
    <Modal
      width={500}
      open={visible}
      footer={false}
      title="Hakediş Faturası Ekleme"
      onCancel={handleCloseModal}
      destroyOnClose
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="BranchId" label="Şube Adı" initialValue={null}>
              <Select style={{ width: 200 }} placeholder="Şube Seçiniz">
                <Option value={null} key="ALL">
                  Tüm Şubeler
                </Option>
                {renderBranchOptions()}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="EndDate"
              label="Tarih"
              rules={[
                {
                  required: true,
                  message: 'Tarih Zorunlu !',
                },
              ]}
            >
              <DatePicker
                placeholder="Tarih Seçiniz"
                format="DD.MM.YYYY"
                disabledDate={disabledDate}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item className="text-align-right">
          <Button
            className="button button__outline mr-3"
            type="ghost"
            htmlType="button"
            disabled={loading}
            onClick={handleCloseModal}
          >
            Vazgeç
          </Button>
          <Button
            className="button button__fill"
            type="primary"
            htmlType="submit"
            disabled={loading}
            loading={loading}
          >
            Fatura Kes
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

AddAnInvoiceModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  branches: PropTypes.arrayOf(
    PropTypes.shape({
      BranchId: PropTypes.string.isRequired,
      BranchTitle: PropTypes.string.isRequired,
    }),
  ),
  identificationNumber: PropTypes.string.isRequired,
};

AddAnInvoiceModal.defaultProps = {
  branches: [],
};

export default AddAnInvoiceModal;
